export enum LoginRecoveryPath {
  ForgotUsername = 'forgot-username',
  ForgotCompanyName = 'forgot-company-name',
  ForgotPassword = 'forgot-password',
  OptionsList = 'options-list',
  EmailSent = 'email-sent',
}
